var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 10L7.397 6.907a.902.902 0 111.22-1.329l3.938 3.692a1 1 0 010 1.46l-3.938 3.692a.902.902 0 11-1.22-1.329L10.833 10z",
    fill: "#5E6E87",
    fillOpacity: 0.8
  })));
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3e %3cpath d='M10.8333 9.99985L7.39656 6.90691C7.00384 6.55348 6.9976 5.93972 7.38304 5.57837C7.73 5.25308 8.26992 5.25308 8.61689 5.57836L12.5551 9.27032C12.9765 9.66539 12.9765 10.3343 12.5551 10.7294L8.6169 14.4216C8.26993 14.7469 7.72999 14.7469 7.38301 14.4216C6.99758 14.0603 7.00381 13.4465 7.39651 13.0931L10.8333 9.99985Z' fill='%235E6E87' fill-opacity='0.8' /%3e %3c/svg%3e";
export { SvgIconNext as ReactComponent };